import {apiCall} from './api'
import {INITIALLINK} from '../shared/entryLink'
import {sendAppSms} from './sms'
import {API_STRAPI_GIFTS} from "../shared/settings"
import {oneTrustKey, oneTrustPurposes} from "./one-trust-constants";

const codeStrapiWithAliases = {
    'albertoa': 'FLYXO90',
    'alexandriat': 'FLYXO90',
    'brookes': 'FLYXO90',
    'chaseb': 'FLYXO90',
    'chases': 'FLYXO90',
    'claytons': 'FLYXO90',
    'connord': 'FLYXO90',
    'danielm': 'FLYXO90',
    'danielac': 'FLYXO90',
    'dannym': 'FLYXO90',
    'gloriac': 'FLYXO90',
    'haydenc': 'FLYXO90',
    'henryb': 'FLYXO90',
    'jacobk': 'FLYXO90',
    'jackf': 'FLYXO90',
    'jamest': 'FLYXO90',
    'jerrfreyl': 'FLYXO90',
    'maxb': 'FLYXO90',
    'michaelf': 'FLYXO90',
    'nicka': 'FLYXO90',
    'seanw': 'FLYXO90',
    'stevec': 'FLYXO90',
    'thomasr': 'FLYXO90',
    'victors': 'FLYXO90',
    'yarond': 'FLYXO90',
    'yasmeens': 'FLYXO90',
    'yenb': 'FLYXO90'
}

const codeWithAliases = {
  'JETCARD': 'FLYXO1000',
  'LOSANGELES': 'FLYXO1000',
  'LASVEGASR': 'FLYXO1000',
  'HOUSTON': 'FLYXO1000',
  'SOUTHFLORIDA': 'FLYXO1000',
  'NEWYORK': 'FLYXO1000',
  'TAMPA': 'FLYXO1000',
  'MIAMI': 'FLYXO1000',
  'SOUTHFLORIDATOCOLORADO': 'FLYXO1000',
  'NEWYORKTOLASVEGAS': 'FLYXO1000',
  'NEWYORKTOLOSANGELES': 'FLYXO1000',
  'FRACTIONALJET': 'FLYXO1000',
  'ORLANDO': 'FLYXO1000',
  'WASHINGTON': 'FLYXO1000',
  'PALMBEACH': 'FLYXO1000',
  'SAUDIARABIA': 'FLYXO1000',
  'TEXAS': 'FLYXO1000',
  'GLOBAL7500': 'FLYXO1000',
  'FLYXO1000AE': 'FLYXO1000',
  'FLYXO1000UK': 'FLYXO1000',
  'TOKEN2049SIN': 'HKO2025',
  'MYS2025': 'HKO2025',
}

export const getProfile = () => apiCall('getprofile')
export const logout = () => {
  window.sessionStorage.removeItem('email')
  return apiCall('logout')
}
export const checkCode = code => apiCall('checkcode', {code: codeWithAliases[code] || code})
export const logOut = () => apiCall('logout')

export const getStrapiDataApi = code => apiCall(API_STRAPI_GIFTS, {'filters[gift_code][$eq]': code}, 'GET')
export const getStrapiData = async (code) => {
  const [data] = await getStrapiDataApi(codeStrapiWithAliases[code] || code)
  if (data?.attributes){
    return data?.attributes ? [data.attributes] : []
  }
  return data ? [data] : []
}

export const getKYCData = () => apiCall('getRegistrationQuestionnaire')
export const activatePromocode = code => apiCall('activatecode6', {code: codeWithAliases[code] || code})
export const resendPassword = email => apiCall('resend', {email})
export const registerV2 = data => apiCall('v2/register', {...data})
export const checkEmail = email => apiCall('checkemail', {email})
export const sendSMS = (phonenumber, captchaResponse) =>
  apiCall('sendsms', captchaResponse ? {phonenumber, captchaResponse} : {phonenumber})
export const isExMember = () => apiCall('isExMember')
export const activateRise = () => apiCall('activateRise')

export const getPrivacySettings = () => apiCall('getPrivacySettings').then(data => data.consent)

export const setPrivacySettings = value =>
  apiCall('setPrivacySettings', {
    consent: {
      emailPasswordRecoveryConsent: true,
      emailSupportConsent: true,
      emailPromoConsent: true,
      phoneCallConsent: true,
      trackingSupportConsent: true,
      trackingResearchConsent: true,
      trackingPromoConsent: value,
    },
  })

export const setFlownBefore = isFlownBefore =>
  apiCall('haveBeenFlown', {beenFlown: isFlownBefore})

export const register = ({gdpr, ...data}) =>
  apiCall('register', {dba: 'XO', ...data, regPage: INITIALLINK}).then(res => {
    if (gdpr) {
      setPrivacySettings(gdpr)
    }
    if (data.phone) {
      sendAppSms(data.phone, data.code || '')
    }
    return res
  })

export const sendToOneTrust = ({gdpr, ...data}) => {
  const source = window.document.location.origin
  fetch('https://privacyportal-de.onetrust.com/request/v1/consentreceipts', {
    body: JSON.stringify({
      identifier: data.email,
      requestInformation: oneTrustKey,
      purposes: oneTrustPurposes,
      dsDataElements: {
        Name: data.name,
        PhoneNumber: data.phone,
        Source: source
      },
      test: !source.includes('flyxo.com')
    }),
    method: 'post'
  })
    .then(res => {
    if(!res?.ok){
      console.log('one trust api error')
    }
  })
    .catch(()=> console.log('one trust api error'))
}

export const updateUser = data => register({...data, update: true})

export const login = (email, password) =>
  apiCall('loginclient', {
    email,
    pass: password,
  }).then(() => getProfile())

export const updatePassword = (oldPassword, newPassword) =>
  apiCall('updatepassword', {
    pass1: oldPassword,
    pass2: newPassword,
  })

export const uploadAvatar = file => {
  const form = new FormData()
  form.append('image', file)

  return apiCall('uploadavatar6', form)
}

export const openSignupBonus = () => {
  apiCall('regBannerAction').catch(() => {
  })
}

export const payDebt = data => apiCall('debtpayment6', {data})


export const marketingSurvey = (questions) =>
  apiCall(
    'marketingSurvey2',
    {
      questions
    },
    'POST'
  )

export const submitPersonalizationQuestionnaire = ({...data}) =>
  apiCall(
    'submitRegistrationQuestionnaire',
    {
      ...data
    },
    'POST'
  )

